import featureFlagSlugs from '@/constants/featureFlagSlugs';
import { getDifferenceInMinutes } from '@/utilities/DateUtils';
import Analytics from '@/mixins/Analytics';

export default {
  name: 'RegisterServiceWorker',
  data() {
    return {
      showReloadPrompt: false,
      reloadToastMessageId: 'reloadToastMessage',
      reloadVisibleStartTime: null,
      reloadVisibleEndTime: null,
      updateSW: undefined,
      offlineReady: false,
      needRefresh: false,
    };
  },
  mixins: [
    Analytics,
  ],
  async mounted() {
    try {
      /* eslint-disable-next-line */
      const { registerSW } = await import('virtual:pwa-register');
      const vm = this;
      this.updateSW = registerSW({
        immediate: true,
        onOfflineReady() {
          vm.offlineReady = true;
        },
        onNeedRefresh() {
          vm.needRefresh = true;
          vm.handleNeedRefresh();
        },
        onRegisteredSW(swUrl, swRegistration) {
          vm.handleSWManualUpdates(swUrl, swRegistration);
        },
        onRegisterError(e) {
          vm.handleSWRegisterError(e);
        },
      });
    } catch {
      /* eslint-disable-next-line */
      console.log('PWA disabled.');
    }
  },

  methods: {
    closePromptUpdateSW() {
      this.offlineReady = false;
      this.needRefresh = false;
      this.showReloadPrompt = false;
    },
    updateServiceWorker() {
      if (this.updateSW) {
        this.updateSW(true);
      }
    },
    handleSWManualUpdates(swUrl, swRegistration) {
      const intervalMS = 60 * 60 * 1000; // hourly
      if (swRegistration) {
        setInterval(async () => {
          if (!(!swRegistration.installing && navigator)) { return; }

          if (('connection' in navigator) && !navigator.onLine) { return; }

          const resp = await fetch(swUrl, {
            cache: 'no-store',
            headers: {
              cache: 'no-store',
              'cache-control': 'no-cache',
            },
          });

          if (resp?.status === 200) { await swRegistration.update(); }
        }, intervalMS);
      }
    },
    async handleNeedRefresh() {
      let forceWebAppRefresh;
      if (this.isAuthorized) {
        try {
          // don't want to hit this endpoint on registration pages
          forceWebAppRefresh = await this.$store.dispatch('fetchFeatureFlagFromAPI', featureFlagSlugs.forceWebAppRefresh);
        } catch (ex) {
          forceWebAppRefresh = true;
        }
      }

      if (forceWebAppRefresh) {
        this.updateApp();
      } else if (this.isAuthorized) {
        this.$root.$emit('acv::app-update-available', { serviceWorkerRegistration: this.updateSW });
        const showWebReloadPrompt = await this.$store.dispatch('fetchFeatureFlagFromAPI', featureFlagSlugs.showWebReloadPromptAfterDeployment);
        this.showReloadPrompt = showWebReloadPrompt;
      }
    },
    updateApp() {
      if ('serviceWorker' in navigator) {
        this.updateServiceWorker();
        this.closePromptUpdateSW();
      } else {
        window.location.reload(true);
      }
    },
    addReloadMessage() {
      this.reloadVisibleStartTime = new Date();
      this.$root.$emit('acv::showToastMessage', {
        id: this.reloadToastMessageId,
        header: 'Update Available',
        severity: 'warning',
        link: '#',
        linkText: 'Reload',
        message: 'Please reload the page to update.',
        dismissible: false,
      });
      this.track(this.eventNames.deploymentReloadPromptSeen);
    },
    removeReloadMessage() {
      this.$root.$emit('acv::clearToastMessageById', this.reloadToastMessageId);
    },
    handleReloadToastMessageLinkClicked($event) {
      this.reloadVisibleEndTime = new Date();
      const promptVisibleDuration = getDifferenceInMinutes(
        this.reloadVisibleStartTime,
        this.reloadVisibleEndTime,
      );
      this.track(this.eventNames.deploymentReloadPromptClicked, {
        prompt_visible_duration_in_minutes: promptVisibleDuration,
      });
      $event.$event.preventDefault();
      this.updateApp();
    },
    handleSWRegisterError(error) {
      this.noticeError(error);
    },
  },
  watch: {
    showReloadPrompt(newValue) {
      if (newValue) {
        this.addReloadMessage();
      } else {
        this.removeReloadMessage();
      }
    },

  },
};
